import { classNamesOrEmpty } from "../../style/common"

export type DescriptionListItem = {
    label: string,
    value: string
}

export type DescriptionListProps = {
    title: string,
    noItemsMessage?: string,
    items: DescriptionListItem[],
    classNames?: {
        container?: string | undefined,
        title?: string | undefined,
        value?: string | undefined,
        label?: string | undefined
    }
}

export default function DescriptionList(props: DescriptionListProps) {
    return (
        <div className={`overflow-hidden rounded-xl border border-color-border flex text-contrast-primary flex-col ${classNamesOrEmpty(props.classNames?.container)}`}>
            <div className="flex items-center gap-x-4 border-b border-color-border bg-tertiary py-1 px-3">
                <div className="text-sm font-medium leading-6">{props.title}</div>
            </div>
            {
                (props.items.length > 0 || !props.noItemsMessage)
                    ? <dl className="-my-3 divide-y divide-tertiary px-3 py-4 text-sm leading-6">
                        {
                            props.items.map((item, index) => (
                                <div key={index} className="flex justify-between gap-x-4">
                                    <dt className={`${classNamesOrEmpty(props.classNames?.label)}`}>{item.label}</dt>
                                    <dd className={`${classNamesOrEmpty(props.classNames?.value)}`}>
                                        {item.value}
                                    </dd>
                                </div>
                            ))
                        }
                    </dl>
                    : <div className={`flex flex-1 items-center justify-center text-sm leading-6 ${classNamesOrEmpty(props.classNames?.label)}`}>
                        <span>{props.noItemsMessage}</span>
                    </div>
            }
        </div>
    )
}